import React, { useState } from "react";

export default function GuessInput({
  query,
  setQuery,
  submitGuess,
  suggestions,
  notice,
  disabled,
}) {
  const [showSuggestions, setShowSuggestions] = useState(false);

  return (
    <section className="glass-card section-card">
      <div className="section-header">
        <h2>Gör din gissning</h2>
      </div>

      <div className="guess-toolbar">
        <div className="guess-search-wrap">
          <input
            type="text"
            value={query}
            disabled={disabled}
            onFocus={() => setShowSuggestions(true)}
            onChange={(event) => {
              setQuery(event.target.value);
              setShowSuggestions(true);
            }}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                setShowSuggestions(false);
                submitGuess();
              }
            }}
            onBlur={() => {
              setTimeout(() => setShowSuggestions(false), 120);
            }}
            className="guess-input"
            placeholder="Skriv en korv, till exempel Falukorv eller Chorizo"
            autoComplete="off"
          />

          {showSuggestions && suggestions.length > 0 && query ? (
            <div className="suggestions-list">
              {suggestions.map((sausage) => (
                <button
                  key={sausage.id}
                  type="button"
                  className="suggestion-item"
                  onClick={() => {
                    setQuery(sausage.name);
                    setShowSuggestions(false);
                  }}
                >
                  <span>{sausage.name}</span>
                  <small>{sausage.country}</small>
                </button>
              ))}
            </div>
          ) : null}
        </div>

        <button
          type="button"
          className="primary-button"
          onClick={() => {
            setShowSuggestions(false);
            submitGuess();
          }}
          disabled={disabled}
        >
          Gissa
        </button>
      </div>

      {notice ? <div className="notice-box">{notice}</div> : null}
    </section>
  );
}